import { Modal } from '../components/Modal';

type Props = {
    onClose: () => void;
    title: string;
    icon: string;
    headline: string;
    desc: string;
    accent: 'gold' | 'red' | 'green';
    actionLabel?: string;
    onAction?: () => void;
};

/** Reusable "result" popup: box win, fast-giveaway lose, withdrawal queued, etc. */
export function ResultPopup({
    onClose,
    title,
    icon,
    headline,
    desc,
    accent,
    actionLabel,
    onAction,
}: Props) {
    return (
        <Modal title={title} onClose={onClose}>
            <div className="popup-hero">{icon}</div>
            <h3
                className="text-center fw-900"
                style={{
                    fontSize: 16,
                    color: accentColor(accent),
                    textShadow: accent === 'gold' ? '0 0 12px rgba(255, 215, 0, 0.4)' : 'none',
                }}
            >
                {headline}
            </h3>
            <p className="popup-text text-center">{desc}</p>
            <button
                type="button"
                className={`action-btn ${
                    accent === 'gold' ? 'btn-gold' : accent === 'red' ? 'btn-red' : 'btn-green'
                }`}
                onClick={() => {
                    onAction?.();
                    onClose();
                }}
            >
                {actionLabel ?? 'OK'}
            </button>
        </Modal>
    );
}

function accentColor(a: Props['accent']) {
    return a === 'gold' ? 'var(--accent)' : a === 'red' ? 'var(--red)' : 'var(--green)';
}
